import { WorkitemTagSchema } from '@rhythmic/types'
import type { CollectionBuildRequestConfig } from '../CollectionRegistry/CollectionBuilder.types'

export const WORKITEM_TAG_TABLE = '"public"."workitemTags"'

export const WorkitemTagConfig: CollectionBuildRequestConfig = {
  collectionType: 'electric',
  table: WORKITEM_TAG_TABLE,
  partitionKey: 'team_id',
  key: 'eid',
  apiEndpoint: '/api/workitems/[workitem_id]/tags',
  where: {},
  schema: WorkitemTagSchema,
}
